/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiCreateGroupHoursOfOperationRequestToJSON, StreemApiCreateGroupHoursOfOperationResponseFromJSON, StreemApiCreateGroupRequestToJSON, StreemApiCreateGroupReservationRequestToJSON, StreemApiCreateGroupReservationResponseFromJSON, StreemApiCreateGroupResponseFromJSON, StreemApiGetGroupHoursOfOperationResponseFromJSON, StreemApiGetGroupReservationResponseFromJSON, StreemApiGetGroupReservationWaitTimeResponseFromJSON, StreemApiGetGroupResponseFromJSON, StreemApiListGroupAvailabilityRequestFromJSON, StreemApiListGroupUsersResponseFromJSON, StreemApiListGroupsResponseFromJSON, StreemApiListUserGroupsResponseFromJSON, StreemApiTransferGroupReservationToRequeueRequestToJSON, StreemApiUpdateGroupHoursOfOperationRequestToJSON, StreemApiUpdateGroupImageUrlRequestToJSON, StreemApiUpdateGroupImageUrlResponseFromJSON, StreemInternalApiSaveGroupAverageCallLengthRequestToJSON, StreemInternalApiSaveGroupAverageCallLengthResponseFromJSON, } from '../models';
/**
 *
 */
export class GroupsApi extends runtime.BaseAPI {
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    async addGroupUserRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling addGroupUser.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling addGroupUser.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling addGroupUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    async addGroupUser(companyCodeOrSid, groupName, userId) {
        await this.addGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    async cancelGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelGroupReservation.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling cancelGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/cancel`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    async cancelGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        await this.cancelGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
    }
    /**
     */
    async cancelQueuedGroupReservationsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelQueuedGroupReservations.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelQueuedGroupReservations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/~cancel-all`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async cancelQueuedGroupReservations(companyCodeOrSid, groupName) {
        await this.cancelQueuedGroupReservationsRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    async confirmMatchedGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling confirmMatchedGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling confirmMatchedGroupReservation.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling confirmMatchedGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/confirm`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    async confirmMatchedGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        await this.confirmMatchedGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    async createGroupRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateGroupRequestToJSON(requestParameters.streemApiCreateGroupRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupResponseFromJSON(jsonValue));
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    async createGroup(companyCodeOrSid, streemApiCreateGroupRequest) {
        const response = await this.createGroupRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateGroupRequest: streemApiCreateGroupRequest });
        return await response.value();
    }
    /**
     * Create hours of operation for a specific group in a company
     * Create hours of operation for group
     */
    async createGroupHoursRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroupHours.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling createGroupHours.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateGroupHoursOfOperationRequestToJSON(requestParameters.streemApiCreateGroupHoursOfOperationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Create hours of operation for a specific group in a company
     * Create hours of operation for group
     */
    async createGroupHours(companyCodeOrSid, groupName, streemApiCreateGroupHoursOfOperationRequest) {
        const response = await this.createGroupHoursRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiCreateGroupHoursOfOperationRequest: streemApiCreateGroupHoursOfOperationRequest });
        return await response.value();
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    async createGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling createGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateGroupReservationRequestToJSON(requestParameters.streemApiCreateGroupReservationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupReservationResponseFromJSON(jsonValue));
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    async createGroupReservation(companyCodeOrSid, groupName, streemApiCreateGroupReservationRequest) {
        const response = await this.createGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiCreateGroupReservationRequest: streemApiCreateGroupReservationRequest });
        return await response.value();
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    async deleteGroupRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroup.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    async deleteGroup(companyCodeOrSid, groupName) {
        await this.deleteGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
    }
    /**
     * Delete hours of operation for a specific group in a company
     * Delete all hours of operation for group
     */
    async deleteGroupHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroupHoursOfOperation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroupHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Delete hours of operation for a specific group in a company
     * Delete all hours of operation for group
     */
    async deleteGroupHoursOfOperation(companyCodeOrSid, groupName) {
        const response = await this.deleteGroupHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        return await response.value();
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    async deleteGroupUserRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroupUser.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroupUser.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteGroupUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    async deleteGroupUser(companyCodeOrSid, groupName, userId) {
        await this.deleteGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    async getGroupRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroup.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupResponseFromJSON(jsonValue));
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    async getGroup(companyCodeOrSid, groupName) {
        const response = await this.getGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        return await response.value();
    }
    /**
     * Get Hours of operation for a group
     * Get group for company
     */
    async getGroupHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupHoursOfOperation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Get Hours of operation for a group
     * Get group for company
     */
    async getGroupHoursOfOperation(companyCodeOrSid, groupName) {
        const response = await this.getGroupHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        return await response.value();
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    async getGroupReservationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservation.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling getGroupReservation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupReservationResponseFromJSON(jsonValue));
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    async getGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        const response = await this.getGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
        return await response.value();
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    async getGroupReservationWaitTimeRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservationWaitTime.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservationWaitTime.');
        }
        if (requestParameters.priority === null || requestParameters.priority === undefined) {
            throw new runtime.RequiredError('priority', 'Required parameter requestParameters.priority was null or undefined when calling getGroupReservationWaitTime.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{priority}/wait_time`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"priority"}}`, encodeURIComponent(String(requestParameters.priority))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGroupReservationWaitTimeResponseFromJSON(jsonValue));
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    async getGroupReservationWaitTime(companyCodeOrSid, groupName, priority) {
        const response = await this.getGroupReservationWaitTimeRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, priority: priority });
        return await response.value();
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    async listGroupAvailabilityRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupAvailability.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupAvailability.');
        }
        const queryParameters = {};
        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/availability`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGroupAvailabilityRequestFromJSON(jsonValue));
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    async listGroupAvailability(companyCodeOrSid, groupName, status, pageSize, pageToken) {
        const response = await this.listGroupAvailabilityRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, status: status, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    async listGroupUsersRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupUsers.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupUsers.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGroupUsersResponseFromJSON(jsonValue));
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    async listGroupUsers(companyCodeOrSid, groupName, pageSize, pageToken) {
        const response = await this.listGroupUsersRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    async listGroupsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroups.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGroupsResponseFromJSON(jsonValue));
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    async listGroups(companyCodeOrSid) {
        const response = await this.listGroupsRaw({ companyCodeOrSid: companyCodeOrSid });
        return await response.value();
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    async listUserGroupsRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listUserGroups.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling listUserGroups.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListUserGroupsResponseFromJSON(jsonValue));
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    async listUserGroups(companyCodeOrSid, userId, pageSize, pageToken) {
        const response = await this.listUserGroupsRaw({ companyCodeOrSid: companyCodeOrSid, userId: userId, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     */
    async saveGroupReservationWaitMetricRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveGroupReservationWaitMetric.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/reservation-metrics`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemInternalApiSaveGroupAverageCallLengthRequestToJSON(requestParameters.streemInternalApiSaveGroupAverageCallLengthRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemInternalApiSaveGroupAverageCallLengthResponseFromJSON(jsonValue));
    }
    /**
     */
    async saveGroupReservationWaitMetric(companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest) {
        const response = await this.saveGroupReservationWaitMetricRaw({ companyCodeOrSid: companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest: streemInternalApiSaveGroupAverageCallLengthRequest });
        return await response.value();
    }
    /**
     * Requeue a group reservation for a specific company and group
     * Requeue group reservation
     */
    async transferGroupReservationToRequeueRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling transferGroupReservationToRequeue.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling transferGroupReservationToRequeue.');
        }
        if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
            throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling transferGroupReservationToRequeue.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/~requeue`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiTransferGroupReservationToRequeueRequestToJSON(requestParameters.streemApiTransferGroupReservationToRequeueRequest),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Requeue a group reservation for a specific company and group
     * Requeue group reservation
     */
    async transferGroupReservationToRequeue(companyCodeOrSid, groupName, reservationSid, streemApiTransferGroupReservationToRequeueRequest) {
        await this.transferGroupReservationToRequeueRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid, streemApiTransferGroupReservationToRequeueRequest: streemApiTransferGroupReservationToRequeueRequest });
    }
    /**
     * Update hours of operation for a specific group in a company
     * Update hours of operation for group
     */
    async updateGroupHoursOfOperationRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateGroupHoursOfOperation.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling updateGroupHoursOfOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/hours`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateGroupHoursOfOperationRequestToJSON(requestParameters.streemApiUpdateGroupHoursOfOperationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateGroupHoursOfOperationResponseFromJSON(jsonValue));
    }
    /**
     * Update hours of operation for a specific group in a company
     * Update hours of operation for group
     */
    async updateGroupHoursOfOperation(companyCodeOrSid, groupName, streemApiUpdateGroupHoursOfOperationRequest) {
        const response = await this.updateGroupHoursOfOperationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiUpdateGroupHoursOfOperationRequest: streemApiUpdateGroupHoursOfOperationRequest });
        return await response.value();
    }
    /**
     * Create image url for a group id
     * Create a group image url
     */
    async updateGroupImageUrlRaw(requestParameters) {
        if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
            throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling updateGroupImageUrl.');
        }
        if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
            throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling updateGroupImageUrl.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/image_url`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateGroupImageUrlRequestToJSON(requestParameters.streemApiUpdateGroupImageUrlRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateGroupImageUrlResponseFromJSON(jsonValue));
    }
    /**
     * Create image url for a group id
     * Create a group image url
     */
    async updateGroupImageUrl(companyCodeOrSid, groupName, streemApiUpdateGroupImageUrlRequest) {
        const response = await this.updateGroupImageUrlRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiUpdateGroupImageUrlRequest: streemApiUpdateGroupImageUrlRequest });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var ListGroupAvailabilityStatus;
(function (ListGroupAvailabilityStatus) {
    ListGroupAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    ListGroupAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    ListGroupAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
    ListGroupAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    ListGroupAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    ListGroupAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    ListGroupAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
})(ListGroupAvailabilityStatus || (ListGroupAvailabilityStatus = {}));
//# sourceMappingURL=GroupsApi.js.map